<template>
	<v-col class="ma-0 pa-0" cols="12" id="header">
    <v-col class="pa-0" cols="12" id="main_content_maxwidthset">
			<v-row class="ma-0 pa-0" align="center" justify="space-between" id="header_body">
				<v-col class="ma-0 pa-0" cols="2" id="header_text">
					{{tc('headerTitle')}}
				</v-col>
				<v-col class="ma-0 pa-0" cols="auto">
					<v-row class="ma-0 pa-0" align="center" justify="end">
						<v-col class="ma-0 pa-0 mr-4" cols="auto" style="width:10rem;">
							<v-select class="ma-0 pa-1 status_select" v-model="selectedCameraStatus"
								:items="cameraStatusList" dense hide-details outlined 
								dark item-text="label" item-value="value"
							></v-select>
						</v-col>
            <v-col class="ma-0 pa-0 mr-5" cols="auto">
              <v-btn id="blue_btn" @click="clickGroupEdit" class="pl-10 pr-10"
                :loading="areaLoading">
                {{tc('storeConditions')}}
              </v-btn>
            </v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-col>
  </v-col>
</template>

<script>
import mixin from '@/mixin';
export default {
	props: {
		areaLoading: { type: Boolean, default: false }
	},
	components: {
		
	},
	mixins: [mixin.common],
	data: () => ({
    selectedCameraStatus: 0,
	}),
	computed: {
    cameraStatusList() {
      return [
        {label: this.$i18n.t('lang.cameraStatus.allCamera'), value: 0},
        {label: this.$i18n.t('lang.cameraStatus.offlineOnly'), value: 1},
      ];
    },
  },
	watch: {
		selectedCameraStatus: function(item) {
			this.$emit('statusChange', item);
		}
	},
	methods: {
    tc(t) {
      return this.$t("lang.cameraStatus." + t);
    },
		clickGroupEdit() {
			this.$emit('clickGroupEdit', true);
		}
	}
}
</script>

<style lang="scss" scoped>
#header {
	background-color: #272A33;
  position: sticky;
	top: 0;
	z-index: 5;
}
#header_body {
	height: 50px;
}
#header_text {
  font-size: 1rem;
  text-align: left;
}
.v-list {
  background: #171921;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item__content{
    color: white;
  }
  .v-list-item--active .v-list-item__content {
    color: white;
  }
  .v-list-item__icon.v-list-group__header__prepend-icon {
    color: white;
  }
}
</style>